<div
  *ngIf="options$ | async as options"
  class="root -{{ state$ | async }}"
  [class.-floating]="!!options.floatingName"
  [class.-blurred]="!(focused$ | async)"
  [style.margin-top.px]="options.topOffset"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary="body"
  [cdkDragDisabled]="!options.floatingName"
  [skyUiPopoverDragPosition]="options.floatingName"
  [@displayAnimation]="state$ | async"
  (@displayAnimation.done)="onDisplayAnimationDone()"
  (skyUiPopoverDragpositionChanged)="onPopoverReady()"
>
  <div *ngIf="options.title" class="title" cdkDragHandle>
    {{ options.title }}

    <sky-ui-icon *ngIf="options.floatingName" class="move" name="new/move" size="s"></sky-ui-icon>

    <div class="right-content">
      <ng-container *ngIf="options.headerContentRef">
        <ng-container
          *ngTemplateOutlet="options.headerContentRef; context: options.headerContentRefContext"
        ></ng-container>
      </ng-container>

      <sky-ui-icon
        *ngIf="options.closingIcon"
        class="close"
        name="new/cross"
        size="s"
        (click)="close()"
      ></sky-ui-icon>
    </div>
  </div>

  <div class="content">
    <ng-container *ngIf="options.contentRef">
      <ng-container
        *ngTemplateOutlet="options.contentRef; context: options.contentRefContext"
      ></ng-container>
    </ng-container>

    <ng-container *ngIf="options.content">
      {{ options.content }}
    </ng-container>
  </div>
</div>
